module.exports = __webpack_public_path__ + "static/media/briefcase.2a8a3732.svg";